import React from 'react'
import PageLayout from 'layouts/PageLayout'
import EmptyHeader from 'containers/EmptyHeader'
import Footer from 'components/Footer'
import Panel from 'components/Panel'
import Button from 'components/Button'
import Caption from 'components/Caption'
import styled from 'styled-components'
import useSignOut from 'modules/user/useSignOut'
import { useQueryParams } from 'utils'
import { StyledPanel } from '../LinkAccountConfirmationPage/LinkAccountConfirmationPage.styles'

const ErrorMessageContainer = styled.pre`
  max-height: 144px;
  overflow: auto;

  margin-top: 16px;
  padding: 8px 24px;

  border-radius: 4px;
  background: ${({ theme }) => theme.colors.background.light.secondary};
  color: ${({ theme }) => theme.colors.text.dark.secondary};
  line-height: 1.5;
  font-size: 0.75rem;
`

export const SsoErrorPage = () => {
  const signOut = useSignOut()
  const { teamName, message } = useQueryParams<'SSO_ERROR'>()

  return (
    <PageLayout header={<EmptyHeader hideUser />} footer={<Footer />}>
      <StyledPanel>
        <Panel.Title>Configuration Error</Panel.Title>
        <Panel.Body>
          <Caption>
            We could not sign you into the <b>{teamName}</b> workspace. Please
            contact the Workspace Administrator to resolve this issue:
          </Caption>
          <ErrorMessageContainer>
            <p>{message}</p>
          </ErrorMessageContainer>
        </Panel.Body>
        <Panel.Footer>
          <Button variant="secondary" onClick={signOut}>
            Sign Out
          </Button>
        </Panel.Footer>
      </StyledPanel>
    </PageLayout>
  )
}
